import apiInstance from "../apiInstance";
import store from "../../state/store";

import widgetPreview from "../Preview/widgetPreview.js";
import accessibilityPreview from "../Preview/widgets/accessibilityPreview.js";
import affordabilityPreview from '../Preview/widgets/affordabilityPreview';
import montlypaymentpreview from '../Preview/widgets/monthlypaymentpreview.js';
import appfolioPreview from "../Preview/widgets/appfolioPreview.js";
import trustPilotPreview from "../Preview/widgets/trustPilotPreview.js";
import tripadvisorpreview from '../Preview/widgets/tripadvisorpreview.js';
import rentvinePreview from "../Preview/widgets/rentvinePreview.js";
import yelpPreview from "../Preview/widgets/yelpPreview.js";
import proratedPreview from "../Preview/widgets/proratedPreview.js";

const handlePreviewHTML = async (widget) => {

  var data = {
    error: "",
    fieldErrors: "",
    serveData: {},
    previewHtml: "",
  };
  const { widgetTypes } = store.getState();

  let type = "";
  for (const item of widgetTypes) {
    if (item.id === widget.widgetType) {
      type = item.name;
      break;
    }
  }

  const dataNeeded = {
    name: widget.widgetTypeName,
    title: widget.title,
    htmlData: widget.htmlData,
    script: widget.widgetTypeScripts,
    isUrlChanged: widget.isUrlChanged,
    widgetId: widget.id,
    firstLoad: widget.firstLoad,
    isReloadRequired: widget.isReloadRequired,
  };

  if (widget.widgetTypeName == "accessibility") {
    // iframe calls the preview Wrapper first
    // data.previewHtml = `<iframe src='${process.env.REACT_APP_CLIENT_URL}/preview?widget=${encodeURIComponent( JSON.stringify(dataNeeded) )}' class="mjwi-preview-iframe"></iframe>`;
    await accessibilityPreview(dataNeeded);
  } else if (widget.widgetTypeName == "appfolio") {
    await appfolioPreview(dataNeeded);
  } else if (widget.widgetTypeName == "trustpilot") {
    await trustPilotPreview(widget);
  } else if (widget.widgetTypeName == "rentvine") {
    await rentvinePreview(dataNeeded);
  } else if (widget.widgetTypeName == 'tripadvisor') {
    await tripadvisorpreview(widget);
  } else if (widget.widgetTypeName == "yelp") {
    await yelpPreview(widget);
  } else if (widget.widgetTypeName == 'prorated') {
    await proratedPreview(dataNeeded);
  } else if (widget.widgetTypeName == 'affordability') {
    await affordabilityPreview({
      ...dataNeeded,
      FirstLoad: widget.FirstLoad // Double ensure it's passed
    });
  } else if (widget.widgetTypeName == 'monthlypayment') {
    await montlypaymentpreview(dataNeeded);

  } else {
    // Skip widgetPreview Wrapper and directly call the preview function
    widgetPreview(dataNeeded);
  }



  return data;
};

export default handlePreviewHTML;
